import { Col, Row } from 'react-bootstrap';
import logoBanistmo from "../../../Resources/Images/Footer/logo_banitsmo.svg";
import logoCardif from "../../../Resources/Images/Footer/logo_cardif.webp";
import logoAssa from "../../../Resources/Images/Footer/logo_assa.webp";
import separator from "../../../Resources/Images/Footer/separator.svg";

function LogoFooter() {
  return (
    <>
        <Row className='d-none d-md-flex'>
            <Col className='p-2 col-12 col-md-auto'>
                <img width={141} height={23} alt="Logo Banistmo" className='logoFooter' src={logoBanistmo}></img>
            </Col>
            <Col className='p-2 d-none d-md-block'>
                <img width={1} height={30} alt="separator" src={separator}></img>            
            </Col>
            <Col className='p-2 col-12 col-md-auto'>
                <img width={104} height={36} alt="Logo Assa" className='logoFooter' src={logoAssa}></img>                       
            </Col>
            <Col className='p-2 d-none d-md-block'>
                <img width={1} height={30} alt="separator" src={separator}></img>            
            </Col>
            <Col className='p-2 col-12 col-md-auto'>
                <img width={118} height={24} alt="Logo Cardif" className='logoFooter' src={logoCardif}></img>                       
            </Col>
        </Row>
        <div className='d-flex flex-row gap-1 d-md-none justify-content-center'>
            <img width={100} height={23} alt="Logo Banistmo" className='logoFooter' src={logoBanistmo}></img>
            <img width={15} height={24} alt="separator" src={separator}></img>            
            <img width={80} height={28} alt="Logo Assa" className='logoFooter' src={logoAssa}></img>    
            <img width={15} height={24} alt="separator" src={separator}></img>            
            <img width={120} height={26} alt="Logo Cardif" className='logoFooter' src={logoCardif}></img>                       
        </div>
    </>
  );
}

export default LogoFooter;